// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "vendors" + "." + "e4e71cc15e3b98082f32" + ".chunk.js";
};